import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface StartPhoneVerificationForCandidateResponse
  extends BackendResponse {}

export interface StartPhoneVerificationForCandidateParameters
  extends NextApiParams {
  phone: string;
}

export const startPhoneVerificationForCandidate = withNextApi<
  StartPhoneVerificationForCandidateResponse,
  StartPhoneVerificationForCandidateParameters
>("/cvp/CvpStartPhoneVerification");
